import { MAX_ONBOARDING_EXPOSURES } from './constants';
import { DEFAULT_HOLDOUT_STATE } from './DEFAULT_HOLDOUT_STATE';
import { getOnboardingHoldoutState } from './getOnboardingHoldoutState';
import { persistState } from './persistState';

/**
 * Record one onboarding exposure (increments exposure count and sets lastSeenAt).
 * No-op if onboarding was completed or exposureCount is already 3.
 */
export function recordOnboardingExposureForHoldout(): void {
	const state = getOnboardingHoldoutState() ?? DEFAULT_HOLDOUT_STATE;

	if (state.onboardingCompleted || state.exposureCount >= MAX_ONBOARDING_EXPOSURES) {
		return;
	}

	persistState({
		...state,
		lastSeenAt: Date.now(),
		exposureCount: state.exposureCount + 1,
	});
}
